import { Component, OnInit } from '@angular/core';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

declare var require;
const Swal = require('sweetalert2');

import { AccountService } from '@services/account.service';

import { UsuarioCambiarPasswordComponent } from "../../../../../pages/centrousuarios/usuarios/usuario/usuario-cambiar-password/usuario-cambiar-password.component";

@Component({
    selector: 'app-my-account',
    templateUrl: './my-account.component.html',
    styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
    name: string;
    userName: string;
    tipo: number;

    constructor(
        private modalService: NgbModal,
        private accountService: AccountService
    ) {
        let account = this.accountService.accountValue;

        this.name = account.name;
        this.userName = account.username;
        this.tipo = account.tipo;
    }

    ngOnInit() {
    }

    changePassword() {
        const modalRef = this.modalService.open(UsuarioCambiarPasswordComponent, { size: '', backdrop: 'static', centered: true, keyboard: false, scrollable: false });
        modalRef.componentInstance.recargarDT.subscribe({
            next: (result: any) => {}
        });
    }

    logout() {
        Swal.fire({
            icon: 'question',
            title: 'Cerrar Sesión',
            text: 'Seguro de cerrar sesión.',
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        })
        .then((result) => {
            if (result.value) {
                this.accountService.logout();
            }
        });
    }

}
